import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {SlugField, FieldReturn, SlugOptions} from '../../types'

const defaultOptions: SlugOptions = {
  source: 'title',
  maxLength: 96,
}

const defaultProps: Partial<SlugField> = {
  required: true,
  description: 'Leave blank to autofill.',
  options: defaultOptions,
}

export const slug = (props?: SlugField, mergeProps?: Partial<SlugField>): FieldReturn =>
  field('slug', mergeConfig('slug', props, mergeProps, defaultProps))
